import React from 'react';
import { useAtomValue } from 'jotai';
import { selectedMetricsAtom, anchorMetricsAtom } from './atoms';
import UserSessionsDropmenu from './Dropdown';
import { VMTitle } from './styled';
import moment from 'moment';
import ExportTable from '../dimension-panel-hz/ExportTable';
import { VM_TIME_LIMIT } from '@components/viewer-sessions/table/Limit';

function ViewerHeader({ mandatoryDimensions, interval }) {
  const anchoredMetrics = useAtomValue(anchorMetricsAtom);
  const exceedTimeLimit = false;
  const selectedMetrics = useAtomValue(selectedMetricsAtom);

  const withinTimeLimit =
  moment(interval.to).diff(moment(interval.from), 'minutes') <= VM_TIME_LIMIT * 60;

  return (
    <VMTitle>
      <div style={{ flex: 1 }}>{`Subset of Users (up to 1500)`}</div>
      {withinTimeLimit && (
        <ExportTable />
      )}
      <UserSessionsDropmenu
        selectedMetrics={selectedMetrics}
        anchoredMetrics={anchoredMetrics}
        exceedTimeLimit={exceedTimeLimit}
        mandatoryDimensions={mandatoryDimensions}
      />
    </VMTitle>
  )
}

export default ViewerHeader;
